import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { handleUpdatedRecords } from "../../../utils/RecordUtils";
import TenantAPI from "../../api/TenantAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

const useLockRecord = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const lockRecord = useMutation({
    mutationFn: ({
      recordID,
      moduleAPIName,
      type,
    }: {
      recordID: string;
      moduleAPIName: string;
      type: "Lock" | "Unlock";
      onSuccess?: () => void;
    }) => {
      return TenantAPI.lockRecord(moduleAPIName, recordID, type).then(
        (data) => {
          const record = data.data.data.data;
          const moduleAPIName = data.data.data.module;

          handleUpdatedRecords(
            queryClient,
            moduleAPIName,
            record,
            tenantID ?? ""
          );

          return record;
        }
      );
    },
    onError: (err: any) => {
      newToastEvent(
        "error",
        getErrorMessage(err, "Failed to lock/unlock record")
      );
    },
    onSuccess: (updatedRecord, { onSuccess }) => {
      newToastEvent(
        "success",
        `The Record has been ${
          updatedRecord._LockedBy ? "locked" : "unlocked"
        }.`
      );
      callFunctionIfExists(onSuccess, updatedRecord);
    },
  });

  return {
    lockRecord: lockRecord.mutate,
    lockingRecord: lockRecord.isPending,
    lockRecordError: lockRecord.error
      ? getErrorMessage(lockRecord.error)
      : null,
  };
};

export default useLockRecord;
